<template>
    <div :id="id">
        <div class="commissioning-sheet__group">
            <div class="account__validation mb-xl" :class="{'is-valid' : validated}">
                <div>
                    <figure class="account__validation-tick">
                        <svg class="icon">
                            <use xlink:href="#tick" />
                        </svg>
                    </figure>
                    <h3 class="h4">{{ heading }}</h3>
                </div>
            </div>
            <form>
                <div class="fields">
                    <slot :validate="validate" />
                </div>
            </form>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        heading: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        validated: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        this.validate();
    },

    methods: {
        validate() {
            const fields = Array.from(document.getElementById(`${this.id}`).querySelectorAll('.singleline.required input, .radio.required input[type="hidden"]'));
            const checkboxes = Array.from(document.getElementById(`${this.id}`).querySelectorAll('input[type="checkbox"]'));

            const fieldsValid = fields.length === 0 || fields.filter(field => field.value === '' || !field.value || field.value === null).length === 0;
            const checkboxesValid = checkboxes.length === 0 || checkboxes.filter(check => check.checked === false).length === 0;

            if (fieldsValid && checkboxesValid) {
                this.$emit('update:validated', true);
            } else {
                this.$emit('update:validated', false);
            }
        }
    },
}
</script>
